export const STORE_REPORT = {
  Summary: '/report/store',
  ExportSummary: '/report/store/export',
  Details: '/report/store/details',
  ExportDetails: '/report/store/export-details',
};
